import {DataApi} from '../data-api';
import {DataApiDistinctValues, DataApiResult, Lawyer} from '../../../types/data-api';
import {DataApiEndpoint} from '../data-api-endpoint';
import {LawyerFilter, LawyerSettings} from '../../../plugins/lawyer/filter';

/**
 * Endpoint for getting lawyers.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class LawyerEndpoint extends DataApiEndpoint {
  protected _api: DataApi;

  constructor(api: DataApi) {
    super(api);
    this._api = api;
  }

  /**
   * Finds lawyers by a filter.
   *
   * @param {LawyerSettings|null} settings Plugin settings
   * @param {LawyerFilter|null} [filter] Filter
   * @returns {Promise<DataApiResult<LawyerEndpoint>>}
   */
  public async find(
    settings: LawyerSettings | null = null,
    filter: LawyerFilter | null = null
  ): Promise<DataApiResult<Lawyer>> {
    return fetch(this.buildUrl(settings, filter, [
      'dataApi[preset]=lawyer'
    ]))
      .then(response => {
        if (response.status !== 200) {
          throw new Error(`Fetching endpoint failed: ${response.status} ${response.statusText}`);
        }
        return response.json();
      })
      .then((response: DataApiResult<Lawyer>) => {
        return response;
      });
  }

  /**
   * Gets distinct values for lawyers.
   *
   * @param {LawyerSettings|null} [settings] Plugin settings
   * @returns {Promise<DataApiDistinctValues>}
   */
  public async distinctValues(settings: LawyerSettings | null = null): Promise<DataApiDistinctValues> {
    return fetch(this.buildUrl(settings, null, [
      'dataApi[preset]=lawyer',
      'dataApi[rows]=9999',
      'dataApi[distinctValues]=1'
    ]))
      .then(response => {
        if (response.status !== 200) {
          throw new Error(`Fetching endpoint failed: ${response.status} ${response.statusText}`);
        }
        return response.json();
      })
      .then((response: DataApiDistinctValues) => {
        return response;
      });
  }
}
